export const LOGIN_TEXT = {
  SUBTITLE: 'common.login_subtitle',
  TITLE: 'common.login_title',
}
